import { KeyValue } from "@angular/common";

export class ConfirmWithReasonDialogData {
  public dialogTitle: string;
  public reasonEnabled: boolean;
  public confirmationText?: string;
  public suggestedReasons?: KeyValue<string, string>[];
}

export class ConfirmWithReasonDialogResultData {
  public reason: string;
  public isConfirmed: boolean;
}
